<template>
  <div class="home">
    <!-- 轮播 -->
    <div class="banner">
      <!--  -->
      <swiper ref="mySwiper" class="swiper" :options="options">
        <swiper-slide v-for="(item) in bannerList " :key="item.id">
          <img :src="item.fullUrl" alt="">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    </div>
    <!-- 内容 -->
    <div style="background: #fff;">
      <div class="container">
          <div class="title">
            <p>我们的使命是</p>
            <h3>简化种植过程及优化临床活动</h3>
          </div>

          <!-- tab  -->
          <div class="tabOne">
            <ul class="tab_title">
                <li @click="active = 0" :class="{active:active==0}">了解埃诺登</li>
                <li @click="active = 1" :class="{active:active==1}">关于CLC</li>
                <li @click="active = 2" :class="{active:active==2}">最新动态</li>
            </ul>
            <div class="content" v-if="active==0">

              <div class="content_left">
                  <img class="img" src="../assets//home/about-pic.png" alt="">
              </div>
              <div class="content_right">
                了解埃诺登
                  <div class="title"> 北京埃诺登科技有限公司</div>
                  <p class="article">       北京埃诺登科技有限公司成立于2013年，是意大利C.L.C Scientific种植系统大中华区总代理，公司销售服务网络覆盖全国，主要产品涵盖口腔种植体、口腔种植修复配件、手术器械和数字化解决方案等，埃诺登践行创新和与时俱进的精神，倾力打造让牙科专家及患者信赖的高品质口腔产品及完善服务。
                  </p>
                  <p class="article"> 埃诺登重视产品的研发和客户教育，与I.D.I.S.（欧洲牙科与种植协会）、意大利帕多瓦大学、米兰大学、哥德堡大学等开展广泛的合作，形成专业的培训服务体系，为推广种植体的临床知识和在市场上保持竞争力提供了学术和科学数据支持。 </p>
                 <router-link to="/about"> <a href="" class="more">了解更多</a></router-link>
                  <div class="hrOIne"></div>

                  <div class="iconBox">
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/efficiency.png" alt="">
                      高效
                    </div>
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/speciality.png" alt="">
                      专业
                    </div>
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/safe.png" alt="">
                      安全
                    </div>
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/beautiful.png" alt="">
                      美观
                    </div>
                  </div>
                </div>
            </div>
            <div class="content" v-if="active == 1">

              <div class="content_left">
                  <img class="img" src="../assets//home/about-pic.png" alt="">
              </div>
              <div class="content_right">
                  <div class="title"> 关于CLC北京埃诺登科技有限公司</div>
                  <p class="article">       北京埃诺登科技有限公司成立于2013年，是意大利C.L.C Scientific种植系统大中华区总代理，公司销售服务网络覆盖全国，主要产品涵盖口腔种植体、口腔种植修复配件、手术器械和数字化解决方案等，埃诺登践行创新和与时俱进的精神，倾力打造让牙科专家及患者信赖的高品质口腔产品及完善服务。
                  </p>
                  <p class="article"> 埃诺登重视产品的研发和客户教育，与I.D.I.S.（欧洲牙科与种植协会）、意大利帕多瓦大学、米兰大学、哥德堡大学等开展广泛的合作，形成专业的培训服务体系，为推广种植体的临床知识和在市场上保持竞争力提供了学术和科学数据支持。 </p>
                <router-link to="/about">  <a href="" class="more">了解更多</a></router-link>
                  <div class="hrOIne"></div>

                  <div class="iconBox">
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/efficiency.png" alt="">
                      高效
                    </div>
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/speciality.png" alt="">
                      专业
                    </div>
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/safe.png" alt="">
                      安全
                    </div>
                    <div class="iconBox_item">
                      <img class="iconImg" src="../assets/home/beautiful.png" alt="">
                      美观
                    </div>
                  </div>
                </div>
            </div>
            <div class="content" v-if="active == 2">

              <div class="content_left">
                  <img class="img" :src="news.coverUrl||'assets//home/about-pic.png'" alt="">
              </div>
              <div class="content_right">
                  <div class="title">{{ news.title }}</div>
                  <p class="article">
                    {{ news.description }}
                  </p>
                <router-link :to="'/newsDetail?id='+news.id"><a href="" class="more">了解更多</a></router-link>
                </div>
            </div>
          </div>
      </div>
    </div>

    <!-- product -->
    <div class="Product_center">
      <div class="pro_container">
         <div class="pro_container_top">
            <h2 class="pro_title">产品中心</h2>
            <ul class="pro_tab">

              <li v-for="(item,id) in proCate" :key="id" @click="handleCatelog(item.id)" :class="{pro_active:curCate == item.id}">{{item.name}}</li>

            </ul>
           <router-link to="/product">
           <div class="pro_more">+ 查看更多</div>
           </router-link>
         </div>
         <div class="pro_content">
            <div class="pro_item" v-for="item in proList" :key="item.id" >
              <div class="pro-img"><img :src="item.coverUrl" alt="" @click="$router.push({path:'/productDetail',query:{id:item.id}})"></div>
              <p class="pro_detail">{{item.title}}</p>
            </div>
         </div>

      </div>
   </div>


   <!-- baner -->
   <div class="bannerBox">
     <div class="banner_continer">
        <div class="banner_continer_left">
          <div class="titleBox">
              <h5>卓越的产品、可靠的质量、贴心的服务</h5>
              <h2>实现企业、医生、患者的全面共赢</h2>
          </div>
          <p class="tit_detail">承接多种商业合作，代理销售等业务</p>
        </div>
        <div class="banner_container_right">
            <div class="right_tit">工作时间：周一至周五早九晚六</div>
            <div class="tel">
              <img src="../assets/home/24gf-telephone2.png" class="telIcon" alt="">
              010-53340557</div>
        </div>
     </div>
   </div>

  <!-- news -->
  <div class="Product_center" style="background: #fff;">
    <div class="pro_container" style="height:600px">
       <div class="pro_container_top">
          <h2 class="pro_title">新闻动态</h2>
          <ul class="pro_tab">
              <li @click="handleNewsType(2)" :class="{pro_active:newsType==2}">新闻</li>
              <li @click="handleNewsType(3)" :class="{pro_active:newsType==3}">培训</li>
              <li @click="handleNewsType(4)" :class="{pro_active:newsType==4}">专家</li>
          </ul>
         <router-link to="/news">
         <div class="pro_more">+ 查看更多</div>
         </router-link>
       </div>
       <div class="new_content">
          <div class="new_item" v-for="item in newsList" :key="item.id">
          <router-link :to="'/newsDetail?id='+item.id">
             <div class="new_item_top">
              <div class="mothon">{{item.day}}</div>
              <div class="year">{{item.year}}</div>
             </div>
             <div class="new_item_center">{{item.title}}</div>
             <div class="new_item_bottom">
               <img :src="item.coverUrl" alt="">
             </div>
          </router-link>
          </div>
    </div>

    </div>

  </div>

  </div>

</template>

<script>
import request from "@/util/request";
const dayjs = require('dayjs')
export default {
  name: 'home',
  data(){
    return {
      news:{},
      page:{page:0,pageSize:6},
      proCate:[],
      proList:[],
      newsList:[
      ],
      bannerList:[],
      active:0,
      curCate:0,
      newsType:2,
      options: {
        loop: true,
        autoplay: {
          //swiper手动滑动之后自动轮播失效的解决方法,包括触碰，拖动，点击pagination,重新启动自动播放
          disableOnInteraction: false,
          // 自动播放时间：毫秒
          delay: 4000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // bulletClass: "my-bullet",
        },
      },


    }
  },
  mounted() {
    this.getBanner()
    this.getCataLog()
    this.handleNewsType(this.newsType)
  },
  methods:{
    handleCatelog(id){
      this.curCate=id
      request.post('/biz/content/list',{...this.page,cateId:id,type:1}).then(res=>{
        this.proList = res.data.content
      })
    },
    handleNewsType(type){
      this.newsType = type
      request.post('/biz/content/list',{...this.page,type:this.newsType}).then(res=>{
        this.newsList = res.data.content
        if(type==2 && this.newsList.length>0){
          this.news= this.newsList[0]
        }
        this.newsList.forEach(e=>{
          e.day=dayjs(e.createTime).format('MM-DD')
          e.year=dayjs(e.createTime).format('YYYY')
        })
      })
    },
    getBanner(){
      request.post('attr/banner/search',{type:1,page:0,pageSize:99999}).then((res)=>
      {this.bannerList= res.data.content})
    },
    getCataLog(){
      request.get('/system/category/getAll').then(res=>{
        const allCatelogs = res.data
        this.proCate = allCatelogs.filter(e=>e.type===1)
        this.curCate = this.proCate && this.proCate.length>0? this.proCate[0].id : null
        if(this.curCate){
          this.handleCatelog(this.curCate)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 新闻中心 */
.new_content {
  margin-top: 88px;
}
.new_content .new_item {
  width: 508px;
  height: 400px;
  background: #F7F8FB;
  float: left;
  margin-right: 35px;
}
.new_item:nth-child(3n) {
  margin-right: 0;
}
.new_item_bottom{
  width: 508px;
  height: 260px;
  overflow: hidden;
}
.new_item_bottom img{
  width: 508px;
  height: 260px;
  transition: all .5s;
}

.new_item:hover.new_item img{
  transform: scale(1.1);
}
.new_item_top {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
  padding: 18px 42px;
}
.new_item_center {
  padding: 15px 40px;
  height: 60px;
  overflow: hidden;
}
.content_active {
  background: #53CABE !important;
}
.text_active {
  color: #fff !important;
}
.banner_container_right {
  width: 500px;
}
.banner_container_right .right_tit {
  width: 345px;
  height: 24px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 48px;
}
.banner_container_right .tel {
  width: 300px;
  height: 50px;
  background: #81D8CF;
  margin-top: 40px;
  line-height: 50px;
  /* text-align: center; */
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding-left: 22px;
  box-sizing: border-box;
}
.tel .telIcon {
  width: 30px;
  height: 28px;
  margin-right: 22px;
}


.bannerBox {
  width: 100%;
  background: url('../assets/home/index-page-bg.png') no-repeat;
  background-size: cover;
}
.banner_continer {
  width: 1600px;
  height: 400px;
  margin: 0 auto;
  padding-top: 90px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.titleBox  {
  width: 478px;
  /* height: 78px; */
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  border-bottom: 1px solid #fff;
}
.titleBox h5 {
  font-size: 18px;
}
.titleBox h2 {
  font-size: 30px;
}
.tit_detail {
  width: 478px;
  height: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 48px;
  margin-top: 30px;
}





/* product */
.Product_center {
  width: 100%;
  background: #F7F8FB;
  padding-top:92px;
}
.Product_center .pro_container {
  width: 1600px;
  margin: 0 auto;
  height:auto;
}
.pro_container_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.pro_title {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 700;
  color: #333333;
}
.pro_tab li{
  float: left;
  width: 149px;
  height: 49px;
  line-height: 49px;
  text-align: center;
  background: #FFFFFF;
  border: 1px solid #E3E3E3;
  margin-right: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.pro_active {
  background: #81D8CF !important;
  color: #fff !important;
  border: none !important;
}
.pro_more {
  /* width: 68px; */
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
}
.pro_content {
  width: 1600px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 85px;
}
.pro_content .pro_item {
  width: 508px;
  height: 352px;
  background: #fff;
  margin-bottom: 38px;
  float: left;
  margin-right: 30px;
}
.pro_item:nth-child(3n){
  margin-right: 0;
}

.pro_content .pro_item .pro-img {
  width: 508px;
  height: 282px;
  overflow: hidden;
}

.pro_content .pro_item .pro-img img{
  width: 508px;
  height: 282px;
  transition: all .5s;
}

.pro_item:hover.pro_item img{
  transform: scale(1.1);
}

.pro_item .pro_detail {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}





.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.container {
  width: 1600px;
  margin: 0 auto;
  padding-top: 86px;
  box-sizing: border-box;
}
.container p {
    font-family:"PingFangSC-Medium";
    font-size: 18px;
    color: #53CABE;
  }
.container h3 {
  margin-top: 20px;
  color: #333333;
  font-size: 24px;
}
.tabOne {
  margin-top: 72px;
  .tab_title {
    width: 1600px;
    display:flex;
  }
  li {
    width: 33.3%;
    height: 52px;
    line-height: 52px;
    text-align: center;
    background: #F7F8FB;;
    font-size: 18px;
    color: #1B1B1B;
  }
  .active {
    background: #81D8CF;
    color: #fff;
  }
}
.content {
  width: 1600px;
  display: flex;
  justify-content: space-between;
  margin-top: 38px;
  padding-bottom: 100px;
}
.content_left {
    width: 520px;
    height:520px;

}
.content_left .img {
  width: 520px;
  height:520px;
}
.content_right {
  width: 964px;
  margin-top: 73px;
  position: relative;
}
.content_right .title {
  height: 23px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 82px;
  margin-bottom: 50px;
}
.content_right .article {
  height:auto;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 36px;
  text-indent: 2em;
}
.content_right .more {
  display: block;
  width: 120px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  background: #81D8CF;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  position: absolute;
  right: 0;
  bottom: 120px;
}
.content_right .hrOIne {
  width: 100%;
  height: 1px;
  background: #E8E8E8;
  margin-top: 88px;
}
.content_right .iconBox {
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 37px;
  background: #fff;
}
.content_right .iconBox .iconBox_item .iconImg{
  width: 39px;
  height: 39px;
  vertical-align: middle;
  margin-right: 16px;
}


.new_item:hover {
    background: #53CABE;
    color: #fff !important;
  }
.new_item:hover .new_item_center {
  color: #fff;
}
.pro_item:hover {
    background: #53CABE;
  }
  .pro_item:hover .pro_detail {
    color: #fff;
  }

  @media (max-width: 1600px) {
    .container{
      width: 1200px;
    }
    .tabOne .tab_title{
      width: 1200px;
    }
    .content{
      width: 1200px;
    }
    .content_right{
      width: 640px;
      margin-top: 20px;
    }

    .Product_center .pro_container{
      width: 1200px;
    }
    .pro_content{
      width: 1200px;
    }
    .pro_content .pro_item {
  width: 380px;
  height: 261px;
  background: #fff;
  margin-bottom: 38px;
}

.pro_content .pro_item .pro-img {
  width: 380px;
  height: 211px;
  overflow: hidden;
}

.pro_content .pro_item .pro-img img{
  width: 380px;
  height: 211px;
  transition: all .5s;
}

.pro_item:hover.pro_item img{
  transform: scale(1.1);
}

.pro_item .pro_detail {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.pro_item:hover {
  background: #53CABE;
  cursor: pointer;
}
.banner_continer{
  width: 1200px;
  height: 300px;
  padding-top: 25px;
 }

 .banner_container_right{
  width: 302px;
  margin-top: 20px;
 }
 .new_item_bottom{
  width: 380px;
  height: 194px;
  overflow: hidden;
 }
 .new_item_bottom img{
  width: 380px;
  height: 194px;
  transition: all .5s;
 }
 .new_item:hover.new_item img{
  transform: scale(1.1);
}

.new_content .new_item{
width: 380px;
height: 330px;
background: #F7F8FB;
float: left;
margin-right: 30px;
 }
.new_item:nth-child(3n){
  margin-right: 0;
}

 .new_content .new_item:hover{
  background: #53CABE;
  cursor: pointer;
 }


  }


</style>
